module.exports = __webpack_public_path__ + "static/media/klatre.3f0ff2b2.png";